import { Box, Button, Typography, styled, Link } from "@mui/material";
import NewsLetterSub from "../assets/NewsLetterSub.svg";
import React from "react";
import Separator from "../assets/Separator.svg";
import { useState } from "react";
import Pagination from "@mui/material/Pagination";

import { ToolCard } from "./Tools";
import Img1 from "../assets/image 1.png";
import Img2 from "../assets/image 2.png";
import Img3 from "../assets/image 3.png";
import Img4 from "../assets/image 4.png";
import Img5 from "../assets/image 5.png";
import Img6 from "../assets/image 6.png";
import Img7 from "../assets/image 7.png";
import Img8 from "../assets/image 8.png";
import Img9 from "../assets/image 9.png";
import Img10 from "../assets/image 10.png";
import Img11 from "../assets/image 11.png";
import Img12 from "../assets/image 12.png";
import Img13 from "../assets/image 13.png";
import Img14 from "../assets/image 14.png";
import Img15 from "../assets/image 15.png";
import Img16 from "../assets/image 16.png";
import Img17 from "../assets/image 17.png";
import Img18 from "../assets/image 18.png";
import Img19 from "../assets/image 19.png";
import Img20 from "../assets/image 20.png";
import Img21 from "../assets/image 21.png";
import Img22 from "../assets/image 22.png";
import Img23 from "../assets/image 23.png";
import Img24 from "../assets/image 24.png";
import Img25 from "../assets/image 25.png";
import Img26 from "../assets/image 26.png";
import Img27 from "../assets/image 27.png";
import NewsCard from "./NewsCard";

export const Text = styled(Typography)({
  fontFamily: "Raleway",
  fontWeight: 600,
  color: "#FFFFFF",
});
const data = [
  {
    id: 26,
    url: "https://facyp.r.ah.d.sendibm5.com/mk/mr/sh/1t6AVsd2XFnIGAANo9glvUps0q1AzI/-BkSULZDhL_o",
    img: Img27,
    desc: "AI Gets Personal:Blackmail Risks, Baby Advice & Talking Machines",
    date: "21 June, 2025",
  },
  {
    id: 25,
    url: "https://facyp.r.ah.d.sendibm5.com/mk/mr/sh/1t6AVsd2XFnIGAANo9glvUps0q1AzI/4gMJsIuh_kBr",
    img: Img26,
    desc: "AI Goes Hollywood,Gets Creative, and Lands in Court",
    date: "07 June, 2025",
  },
  {
    id: 24,
    url: "https://facyp.r.ah.d.sendibm5.com/mk/mr/sh/1t6AVsd2XFnIGAANo9glvUps0q1AzI/n4hyyzG2DV3C",
    img: Img25,
    desc: "This Week in AI:Big Dreams, Bold Tools & Bumpy Roads",
    date: "May 24, 2025",
  },
  {
    id: 23,
    url: "https://facyp.r.ah.d.sendibm5.com/mk/mr/sh/1t6AVsd2XFnIGBppVjigYAXwFwn67s/UXgHcThLEs9G",
    img: Img24,
    desc: "This Week in AI: Game-Changing Tools from Google, Amazon,and More!",
    date: "May 10, 2025",
  },
  {
    id: 22,
    url: "https://facyp.r.bh.d.sendibt3.com/mk/mr/sh/1t6AVsg9Ynm8rNO6wyWIWwZ3UX3hbU/U4lth2aUraqn",
    img: Img23,
    desc: "Big Tech’s AI Push: Veo 2, Meta’s EU Data Shift, and YouTube’s Music Maker",
    date: "April 19, 2025",
  },
  {
    id: 21,
    url: "https://facyp.r.bh.d.sendibt3.com/mk/mr/sh/1t6AVsg9Ynm8rNO6wyWIWwZ3UX3hbU/_c9nUfVnvFxK",
    img: Img22,
    desc: "AI Innovations, Flirting Games, and the Battle Against Crawlers",
    date: "April 05, 2025",
  },
  {
    id: 20,
    url: "https://facyp.r.bh.d.sendibt3.com/mk/mr/sh/1t6AVsg9Ynm8rNO6wyWIWwZ3UX3hbU/4hiW652MRkm4",
    img: Img21,
    desc: "AI is Leveling Up: Student Creations, Smarter Tools and Supercomputers",
    date: "Mar 22, 2025",
  },
  {
    id: 19,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=4c7b8aac20",
    img: Img20,
    desc: "This Week in AI Evolution: Stargate, AI Agents and Tiny Models",
    date: "Jan 25, 2025",
  },
  {
    id: 18,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=0f429af2ad",
    img: Img19,
    desc: "AI Unleashed: Bold Innovations, Controversies, and the Road Ahead in 2025",
    date: "Jan 11, 2025",
  },
  {
    id: 17,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=ea8dc0dd8a",
    img: Img18,
    desc: "This Week in AI: Misleading Searches, Humanoid Robots, and a School Run by Machines",
    date: "Dec 28, 2024",
  },
  {
    id: 16,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=0b466ee366",
    img: Img17,
    desc: "AI Revolution: Hyperrealism, Safety, and Ethical Challenges",
    date: "Dec 14, 2024",
  },
  {
    id: 15,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=a864253e1d",
    img: Img16,
    desc: "AI Showdown: Security Breakthroughs, Creative Revolutions, and Rising Challengers",
    date: "Nov 30, 2024",
  },
  {
    id: 14,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=77be8f7a0e",
    img: Img15,
    desc: "AI in the Crosshairs: Breakthroughs, Blunders, and the Battle for Trust",
    date: "Nov 16, 2024",
  },
  {
    id: 13,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=d76432dad7",
    img: Img14,
    desc: "AI’s Expanding Role: From Mental Health Support to Controversial Innovations and Creative Frontiers",
    date: "Nov 02, 2024",
  },
  {
    id: 12,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=a3102eecff",
    img: Img13,
    desc: "AI’s Global Impact: From Cyber Threats to Continuous Tech Advancements",
    date: "Oct 19, 2024",
  },
  {
    id: 11,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=539068bb45",
    img: Img12,
    desc: "Alibaba's 100+ Models, Meta's New Smart Glasses, FTC Actions, and Industry Highlights",
    date: "Oct 05, 2024",
  },
  {
    id: 10,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=42e284d2af",
    img: Img11,
    desc: "From AI Sidekicks to Skipping Bar Lines: Who's Winning the Race for Digital Domination?",
    date: "Sep 14, 2024",
  },
  {
    id: 9,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14186185",
    img: Img10,
    desc: "CogVideoX Challenges Sora, OpenAI’s Strawberry & AI Taking Over Police work",
    date: "Aug 31, 2024",
  },
  {
    id: 8,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14185906",
    img: Img9,
    desc: "Flux.1 takes on the Giants, Grok-2 shakes up Image Gen, and Relationships with Chatbots?",
    date: "Aug 17, 2024",
  },
  {
    id: 7,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=f00e45bc0f",
    img: Img8,
    desc: "Google’s Gemini 1.5 Pro Dominates, Alan Turing's Interactive Display and the EU AI Act in now in Effect",
    date: "Aug 03, 2024",
  },
  {
    id: 6,
    url: "https://us17.campaign-archive.com/?u=06000c472ad27f1e07041f567&id=a6edd75db3",
    img: Img7,
    desc: "AI Innovations Unveiled: From Education to Healthcare and Beyond",
    date: "July 20, 2024",
  },
  {
    id: 5,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14184747",
    img: Img6,
    desc: "AI Innovations & Controversies: Zoom's transformation, Microsoft unveils AI exploit, Poe & Perplexity under fire and Meta's image dilemma",
    date: "July 06, 2024",
  },
  {
    id: 0,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14184522",
    img: Img1,
    desc: "OpenAI’s new rival from ex Chief Scientist, Anthropic’s New Claude 3.5 Sonnet Model, Amazon’s Gen Expansion and more…",
    date: "June 22, 2024",
  },
  {
    id: 1,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14184059",
    img: Img2,
    desc: "Elon Musk’s xAI endeavour, Google’s unstable AI-Search and Llama 3’s crown at stake",
    date: "June 08, 2024",
  },
  {
    id: 2,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14183735",
    img: Img3,
    desc: "Major AI Product Releases and AI Seoul Summit",
    date: "May 25, 2024",
  },
  {
    id: 3,
    url: "https://mailchi.mp/veracious/the-new-frontier-for-ai-ai-agents-14182795",
    img: Img4,
    desc: "Ethics of Foundation Models and much more",
    date: "May 11, 2024",
  },
  {
    id: 4,
    url: "https://mailchi.mp/9592c370ae6c/the-new-frontier-for-ai-ai-agents",
    img: Img5,
    desc: "The new frontier for AI: AI Agents 🚀",
    date: "April 27, 2024",
  },
];
const NewsLetterComp = () => {
    const cardsPerPage = 10;


  const [page, setPage] = useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const startIndex = (page - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const paginatedData = data.slice(startIndex, endIndex);
  const totalPages = Math.ceil(data.length / cardsPerPage);

  return (
    <>
      <Box sx={{ px: 3, py: { lg: 3 }, position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: {
              xs: 4,
              sm: 0,
            },
          }}
        >
          <Link
            // href="https://veracious.us17.list-manage.com/subscribe?u=06000c472ad27f1e07041f567&id=481be45865"
            href="https://57927b91.sibforms.com/serve/MUIFACjnqNUefDpSiojhOuNkkIEbfsBJK-hG9jGMpZHvtBYbVY5b8Y6qIfrLFrvm9mD6dnZ_m4zGq-u9bjCwMvuQHfxqEGm3F0qLLsMeL5aT2uu5BFlIkSRmG5zwGE6Z-zb_XN9iS-btTBYdT8agLzZXOYF8r4k0_-fPSZNee3flMfpiPB81jZvyv0fkTGsJgBzlgDPt7FCd2k9b"
            target="_blank"
          >
            <Button
              // to="https://veracious.us17.list-manage.com/subscribe?u=06000c472ad27f1e07041f567&id=481be45865"
              to="https://57927b91.sibforms.com/serve/MUIFACjnqNUefDpSiojhOuNkkIEbfsBJK-hG9jGMpZHvtBYbVY5b8Y6qIfrLFrvm9mD6dnZ_m4zGq-u9bjCwMvuQHfxqEGm3F0qLLsMeL5aT2uu5BFlIkSRmG5zwGE6Z-zb_XN9iS-btTBYdT8agLzZXOYF8r4k0_-fPSZNee3flMfpiPB81jZvyv0fkTGsJgBzlgDPt7FCd2k9b"
              variant="contained"
              sx={{
                background: "#21426B !important",
                textTransform: "none",
                // height:'32px'
                px: "16px",
                py: "8px",
                borderRadius: "6px",
                boxShadow: "0px 40px 40px 0px #00000040",
                "&:hover": {
                  background: "#2e507f !important", // slightly lighter background on hover
                },
              }}
            >
              <img style={{ marginRight: "16px" }} src={NewsLetterSub} alt="" />

              <Text
                sx={{
                  fontSize: "14px",
                  backgroundImage:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.3) 100%)",
                  backgroundClip: "text",
                  // WebkitTextFillColor: "transparent",
                }}
              >
                Subscribe to our Newsletter
              </Text>
            </Button>
          </Link>
        </Box>

        <Box
          sx={{
            pt: 3,
            display: "flex",
            justifyContent: "center",
            gap: { xs: 0, sm: 1 },
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Text sx={{ fontWeight: 400, fontSize: { xs: "15px", sm: "14px" } }}>
            The Bi-weekly AI newsletter. Read by over 100,000
          </Text>
          <Text
            sx={{
              fontWeight: 400,
              fontSize: { xs: "15px", sm: "14px" },
              mt: { xs: 1, sm: 0 },
            }}
          >
            Researchers, Students, Enthusiasts and Industry professionals around
            the world.
          </Text>
        </Box>

        <Box
          sx={{
            pt: { xs: 1, sm: 0 },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img width="100%" src={Separator} alt="" />
        </Box>

        <Box
          sx={{
            py: { xs: 3, sm: 1 },
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            gap: 4,
            flexWrap: "wrap",
            cursor: "pointer",
          }}
        >
         {paginatedData.map((item) => {
  return (
    <NewsCard
      key={item.id}
      url={item.url}
      img={item.img}
      desc={item.desc}
      date={item.date}
    />
  );
})}

        </Box>
      </Box>
 <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
  <Pagination
    count={totalPages}
    page={page}
    onChange={handleChange}
    variant="outlined"
    shape="rounded"
    sx={{
      "& .MuiPaginationItem-root": {
        color: "#cccccc",        // light gray text
        borderColor: "#cccccc",  // light gray border
      },
    }}
  />
</Box>



    </>
  );
};

export default NewsLetterComp;
